import h, { getCountry } from '../../../helpers/common';
import { useEffect, useMemo, useState } from 'react';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { ICmsCarouselService } from '@intigral/domain/lib/application/services/CmsCarouselService';
import user from '../../../helpers/user';
import url from '../../../helpers/url';
import { catupListTransformer } from '../../../utils/transformResponse/catchupResponse';
import CatchUpDetail from './CatchUpDetail';
import useCatchupActions from '../../../hooks/useCatchupActions';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { Modal } from '../../ui/Modal';
import useCatchupDetailOverlay from '../../../hooks/useCatchupDetailOverlay';
const useLoadItemDataById = (
    paId: string | null,
    channelGuid: string,
    callSign: string,
    shouldCallApi,
    isMixCatchup = false
) => {
    return useQuery({
        queryKey: ['catchupDetail', paId],
        enabled: true,
        queryFn: async () => {
            if (channelGuid && paId && callSign && shouldCallApi) {
                const cmsCarouselService = container.resolve<ICmsCarouselService>(DI.SERVICES.ICmsCarouselService);
                const response = await cmsCarouselService.getCatchUpCarousel(
                    '',
                    user.getAPIKey(),
                    {
                        device: h.getDevice(),
                        country: getCountry(),
                        bySubscriptionGuidsPipeEncoded: '',
                        ...(!isMixCatchup ? { callSign: callSign } : {}),
                    },
                    isMixCatchup //isMixCatchup flag to check which API to call
                );
                const selectedData = response?.entries?.find(
                    (item) => item.id === paId && item.channelGuid === channelGuid
                );
                if (selectedData) {
                    return catupListTransformer(selectedData);
                }
                // Return null if no data found
                return null;
            }
            // Return null if conditions not met
            return null;
        },
        refetchOnWindowFocus: false,
    });
};

type CatchUpDetailModalPropsType = {
    selectedCatchupData?: any;
    closeModal?: () => void;
};
export default function CatchUpDetailModal({ selectedCatchupData, closeModal }: CatchUpDetailModalPropsType) {
    const [openModal, setOpenModal] = useState(false);
    const { navigateToPlayer } = useCatchupActions();
    // const dispatch = useDispatch();
    const movieOverlay = useSelector((state: any) => state.movieOverlay);
    const callSignPrams = url.getQuery('callSign');
    const { closeCatchupDetailOverlay } = useCatchupDetailOverlay();

    const channelGuid = useMemo(
        () => (url.getQuery('channelGuid') !== null ? url.decodeValue(url.getQuery('channelGuid')) : null),
        [url.getQuery('channelGuid')]
    );
    const paId = useMemo(
        () => (url.getQuery('paId') !== null ? url.decodeValue(url.getQuery('paId')) : null),
        [url.getQuery('paId')]
    );
    const callSign = useMemo(() => {
        return callSignPrams !== null ? url.decodeValue(callSignPrams) : null;
    }, [callSignPrams]);

    const isMixCatchup = url.getQuery('isMixed') === 'true' ? true : false;

    useEffect(() => {
        // movieOverlay.isCatchupVisible is only used to check if the modal is already open.
        // If it's not open, we avoid opening it from the deeplink, which helps reduce unnecessary API calls.
        if ((channelGuid && paId && callSign) || (selectedCatchupData && !movieOverlay.isCatchupVisible)) {
            setOpenModal(true);
        } else {
            setOpenModal(false);
        }
    }, [channelGuid, paId, callSign, selectedCatchupData, movieOverlay.isCatchupVisible]);

    const {
        isLoading: isCatchupLoading,
        isError: isCatchupError,
        data,
    } = useLoadItemDataById(paId, channelGuid, callSign, !selectedCatchupData, isMixCatchup);

    const catchupData = data || selectedCatchupData;

    const handleModalClose = () => {
        setOpenModal(false);
        closeCatchupDetailOverlay();
        closeModal?.();
    };

    const handlePlayClick = (catchupData) => {
        navigateToPlayer(catchupData);
    };

    return openModal ? (
        <Modal useFlexLayout={false} open={openModal} onOpenChange={handleModalClose}>
            <>
                <CatchUpDetail
                    isCatchupLoading={isCatchupLoading}
                    catchupData={catchupData}
                    handlePlayClick={handlePlayClick}
                    isMixCatchup={isMixCatchup}
                />
            </>
        </Modal>
    ) : (
        <></>
    );
}
